<template>
    <div>
        <ProjTab :current_tab="'Sudionici'" :project_info="proj_data" />
        <div class="case-spisi">
            <div class="spisi-left sudionici-left">
                <!-- Close case-folders-line -->
                <div class="opening-folder opening-folder-sudionici">
                    <div class="open-folder-line">
                        <div class="open-folder-line-left switch-sudionici-wrapp">
                        </div>
                        <div class="open-folder-line-right">
                            <div class="sudionici-dropdown">
                                {{ $t("page_2.page_2_2.f1") }}:
                                <select class="drop-filter" v-model="selected_uloga" @change="filterByUloga()" id="search-group">
                                    <option value="all">{{ $t("page_2.page_2_2.all_f") }}</option>
                                    <option v-for="(uloga, key) in uloge" :key="key" :value="uloga">{{ uloga }}</option>
                                </select>
                                <img class="calendar-arrow" src="@/assets/img/strelica_dupla.svg" />
                            </div>
                        </div>
                    </div>
                    <div class="sudionici-main-wrapper">
                        <div class="sudionici-row row-title-row">
                            <div class="sudionici-column sudionici-column1">
                                {{ $t("page_2.page_2_2.table.col_1") }}
                                <div class="downarrow"></div>
                            </div>
                            <div class="sudionici-column sudionici-column2">
                                {{ $t("page_2.page_2_2.table.col_2") }}
                                <div class="downarrow"></div>
                            </div>
                            <div class="sudionici-column sudionici-column3">
                                {{ $t("page_2.page_2_2.table.col_3") }}
                                <div class="downarrow"></div>
                            </div>
                            <!-- <div class="sudionici-column sudionici-column4"></div> -->
                            <!-- <div class="sudionici-column sudionici-column5"></div>
              <div class="sudionici-column sudionici-column6"></div> -->
                        </div>
                        <div class="sudionici-row" v-for="(legal, key) in odvjetnici" :key="'10' + key">
                            <router-link :to="'/osobe/law/' + legal.odvjetnik.uid"
                                class="sudionici-column sudionici-column1">
                                {{ legal.odvjetnik.ime }}
                                {{ legal.odvjetnik.prezime }}
                            </router-link>
                            <div class="sudionici-column sudionici-column2">{{ $t("page_2.page_2_2.fix_val_2") }}</div>
                            <div class="sudionici-column sudionici-column3">
                                {{ legal.project_odvjetnik_status.naziv }}
                            </div>

                        </div>
                        <div class="sudionici-row" v-for="(osoba, key) in pravne" :key="'20' + key">
                            <router-link :to="'/osobe/prav/' + osoba.pravna_osoba.uid"
                                class="sudionici-column sudionici-column1">
                                {{ osoba.pravna_osoba.ime }}
                            </router-link>
                            <div class="sudionici-column sudionici-column2">{{ $t("page_2.page_2_2.fix_val_3") }}</div>
                            <div class="sudionici-column sudionici-column3">
                                {{ osoba.oznake_status.status_name }}
                            </div>

                        </div>

                        <div class="sudionici-row" v-for="(osoba, key) in fizicke" :key="'30' + key">
                            <router-link :to="'/osobe/fiz/' + osoba.fizicka_osoba.uid"
                                class="sudionici-column sudionici-column1">
                                {{ osoba.fizicka_osoba.ime }} {{ osoba.fizicka_osoba.prezime }}
                            </router-link>
                            <div class="sudionici-column sudionici-column2">{{ $t("page_2.page_2_2.fix_val_3") }}</div>
                            <div class="sudionici-column sudionici-column3">
                                {{ osoba.oznake_status.status_name }}
                            </div>

                        </div>


                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import draggable from "vuedraggable";
import auth from "@/services/auth";
import ProjTab from "@/components/projectComponents/ProjTab.vue"
import {getProjData} from "@/router/project/handler"
export default {
    components: {
        draggable,
        ProjTab
    },
    data() {
        return {
            accessToken: "",
            proj_data: {broj_projekta:""},
            uloge: [],
            odvjetnici: [],
            pravne: [],
            fizicke: [],
            selected_uloga: 'all',
        };
    },
    watch: {

    },
    async created() {
        this.accessToken = this.$store.state.aToken 

        await getProjData(this.$route.params.uid).then(async (response) => {

            this.proj_data = response;
            this.odvjetnici = this.proj_data.connect_project_odvjetnik;
            this.pravne = this.proj_data.connect_project_legal;
            this.fizicke = this.proj_data.connect_project_private;
            this.findAllUloge();
        })


        // console.log(this.accessToken)
    },
    methods: {
        findAllUloge() {
            this.uloge = [];
            this.proj_data.connect_project_private.forEach((el) => this.uloge.push(el.oznake_status.status_name))
            this.proj_data.connect_project_legal.forEach((el) => this.uloge.push(el.oznake_status.status_name))
            this.proj_data.connect_project_odvjetnik.forEach((el) => this.uloge.push(el.project_odvjetnik_status.naziv))
            this.uloge = [...new Set(this.uloge)];
        },
        filterByUloga() {
            this.selected_spis = 'all'
            if (this.selected_uloga != 'all') {
                this.fizicke = this.proj_data.connect_project_private.filter((el) => el.oznake_status.status_name == this.selected_uloga);
                this.pravne = this.proj_data.connect_project_legal.filter((el) => el.oznake_status.status_name == this.selected_uloga);
                this.odvjetnici = this.proj_data.connect_project_odvjetnik.filter((el) => el.project_odvjetnik_status.naziv == this.selected_uloga);
            } else {
                this.odvjetnici = this.proj_data.connect_project_odvjetnik;
                this.pravne = this.proj_data.connect_project_legal;
                this.fizicke = this.proj_data.connect_project_private;
            }

        },
    },
    mounted() { },
};
</script>

<style>
</style>